import React, { useState } from 'react';
import { TextField, Button, Box, Grid, FormLabel, InputLabel, FormControlLabel, RadioGroup, Radio, MenuItem, Select } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles from './useStyles'
import ReactGA from "react-ga";
import { ErrorMessage } from '@hookform/error-message'
import { singleInputValidator } from '../commons/utils';

const PasoTresForm = ({ numIngreso, setNumIngreso, fechaIngreso, setFechaIngreso, mediadorTitular, setMediadorTitular,
  primerSuplente, setPrimerSuplente, segundoSuplente, setSegundoSuplente, descProblema, setDescProblema, errors, setError, nombreprimerSuplente }) => {


  const classes = useStyles();

  const [subTitulo, setSubTitulo] = useState('Identificación del Juicio Arbitral en Tramitación en la Superintendencia')

  const handleChangeMediador = (event) => {
    setMediadorTitular(event.target.value);
  };

  const handleChangeNumIngreso = evt => {
    setNumIngreso(evt.target.value)
  }

  const handleChangeFechaIngreso = evt => {
    setFechaIngreso(evt.target.value)
  }

  const handleChangePrimerSuplente = evt => {
    setPrimerSuplente(evt.target.value)
  }

  const handleChangeSegundoSuplente = evt => {
    setSegundoSuplente(evt.target.value)
  }

  const handleChangeDescProblema = evt => {
    setDescProblema(evt.target.value)
  }

  const printPrimerSuplente = () => {
    return nombreprimerSuplente.map((item,index)=>{
      //console.log("item", item)
      return <MenuItem  key={index} value={item.id_mediador}>{item.nombre_completo} {item.apellidopat} {item.apellidomat}</MenuItem>
    })
  }
  //ReactGA.pageview('/paso3');
  return (


    <>
     
      <Grid>

      

        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>Mediadores Seleccionados (En orden de su preferencia)</h3>
        </Box>

        <div class="MuiBox-root MuiBox-root-37">
            <h3 style={{ color: 'rgb(0, 0, 0)', fontSize: 16, marginLeft: 45}}> 
              Para mas información acceda al registro de mediadores con aseguradoras: 
              <a href="http://www.supersalud.gob.cl/acreditacion/673/w3-propertyvalue-6168.html" target="_blank">Ver mediadores</a>
            </h3>
        </div>


        <FormControl className={classes.formControlComponent} size="small">
          <InputLabel id="selectlabelMediador1" variant="outlined" >Mediador Titular</InputLabel>
          <Select
            required
            labelId="aseguradoralabel"
            id="selectlabelAseguradora"
            variant="outlined"
            value={mediadorTitular}
            label="Mediador Titular"
            onChange={handleChangeMediador}
            name="mediadorTitular"
        
          >
            {printPrimerSuplente()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="mediadorTitular"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
          <InputLabel id="selectlabelMediador2" variant="outlined" >Primer Suplente</InputLabel>
          <Select
            required
            labelId="aseguradoralabel"
            id="selectlabelAseguradora"
            variant="outlined"
            value={primerSuplente}
            name="primerSuplente"
            label="Primer Suplente"
            onChange={handleChangePrimerSuplente}
           
          >
            {printPrimerSuplente()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="primerSuplente"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
          <InputLabel id="selectlabelMediador2" variant="outlined" >Segundo Suplente</InputLabel>
          <Select
            required
            labelId="aseguradoralabel"
            id="selectlabelAseguradora"
            variant="outlined"
            value={segundoSuplente}
            label="Segundo Suplente"
            onChange={handleChangeSegundoSuplente}
            name="segundoSuplente"
          
          >
           {printPrimerSuplente()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="segundoSuplente"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small"> </FormControl>

        <Box display="flex" justifyContent="start" style={{ color: '#184ba3', fontSize: 16, fontWeight: 'bold', marginLeft: 40, marginRight: 40, paddingTop: '15px', paddingBottom: '15px' }} >
          <TextField fullWidth
            id="solicitudconcreta"
            variant="outlined"
            label="Descripción del Problema"
            multiline
            rows={4}
            value={descProblema}
            onChange={handleChangeDescProblema}
            name="descProblema"
            onBlur={() => {
              setDescProblema(descProblema.trim())
              singleInputValidator(descProblema,"descProblema",setError, [])
            }}

          />

        </Box>
        <ErrorMessage
            style={{ color: 'red' }}
            name="descProblema"
            as="div"
            errors={errors}
          />
      </Grid>



    </>



  )
}

export default PasoTresForm